import { APY_BPS, DAY, TERMS, decimalAmount, type TermMonths } from "./economics";

export type DepositSuccess = { amount: string; asset: "FUEL" | "stFUEL"; term: TermMonths; openingPrice: string; reward: string; maturity: number; transactionId: string; createdAt: number };

export function depositSuccess(amount: string, asset: DepositSuccess["asset"], term: TermMonths, priceE6: string, transactionId: string, now = Date.now()): DepositSuccess {
  const collateral = BigInt(amount);
  const openingValue = collateral * BigInt(priceE6) / 1_000_000_000n;
  const reward = openingValue * BigInt(APY_BPS) / 10_000n * BigInt(TERMS[term].days) / 365n;
  return { amount: decimalAmount(collateral, 9), asset, term, openingPrice: decimalAmount(BigInt(priceE6), 6), reward: decimalAmount(reward, 6), maturity: Math.floor(now / 1_000) + TERMS[term].days * DAY, transactionId, createdAt: now };
}

export function readDepositSuccess(raw: string | null, now = Date.now()) {
  try {
    const value = JSON.parse(raw || "null") as DepositSuccess | null;
    const age = value ? now - value.createdAt : -1;
    const decimal = /^\d+(?:\.\d+)?$/;
    return value && decimal.test(value.amount) && (value.asset === "FUEL" || value.asset === "stFUEL") && [6, 9, 12].includes(value.term) && decimal.test(value.openingPrice) && decimal.test(value.reward) && Number.isFinite(value.maturity) && /^0x[0-9a-f]{64}$/i.test(value.transactionId) && age >= 0 && age < 10 * 60_000 ? value : null;
  } catch { return null; }
}
